export enum EHeaderBackButtonType {
  ARROW = 'ARROW',
  INNER_ARROW = 'INNER_ARROW',
  CLOSE = 'CLOSE',
}
